'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var useTimeValues_hook = require('./use-time-values.hook-1a18dd0a.js');
var parseTime_util = require('./parse-time.util-fac3de5c.js');

var is24HourDisabled = function (hour, _a, _b) {
    var _c = tslib_es6.__read(_a, 1), minHours = _c[0];
    var _d = tslib_es6.__read(_b, 1), maxHours = _d[0];
    return hour < minHours || hour > maxHours;
};
var is12HourDisabled = function (hour, _a, min, max) {
    var _b = tslib_es6.__read(_a, 1), valueHours = _b[0];
    var hourIn24Format = valueHours >= 12 ? (hour % 12) + 12 : hour % 12;
    return is24HourDisabled(hourIn24Format, min, max);
};
var isHourDisabled = function (is12h, hour, value, min, max) {
    if (is12h) {
        return is12HourDisabled(hour, value, min, max);
    }
    return is24HourDisabled(hour, min, max);
};
var useHourValues = function (is12h, value, min, max) {
    var valueParsed = parseTime_util.parseTime(value);
    var minParsed = parseTime_util.parseTime(min);
    var maxParsed = parseTime_util.parseTime(max);
    return Array
        .from({ length: is12h ? 12 : 24 }, function (_, index) { return (is12h ? index + 1 : index); })
        .map(function (item) { return ({
        value: useTimeValues_hook.generateTimePartString(item),
        disabled: isHourDisabled(is12h, item, valueParsed, minParsed, maxParsed),
    }); });
};

var useHoursChangeHandler = function (is12h, handleChange, amPm, minutes) { return React.useCallback(function (selected) {
    if (!is12h) {
        handleChange(selected + ":" + minutes);
    }
    else {
        var parsedHours = parseInt(selected, 10) % 12;
        var newHoursValue = amPm === 'pm' ? parsedHours + 12 : parsedHours;
        handleChange(useTimeValues_hook.generateTimePartString(newHoursValue) + ":" + minutes);
    }
}, [is12h, handleChange, amPm, minutes]); };

var HourValues = function (_a) {
    var is12h = _a.is12h, value = _a.value, handleChange = _a.onChange, valueHeight = _a.valueHeight, maxVisible = _a.maxVisible, min = _a.min, max = _a.max;
    var _b = useTimeValues_hook.useTimeValues(value, is12h), formattedHours = _b.formattedHours, minutes = _b.minutes, amPm = _b.amPm;
    var handleHoursChange = useHoursChangeHandler(is12h, handleChange, amPm, minutes);
    var hourValues = useHourValues(is12h, value, min, max);
    return (React__default.createElement(useTimeValues_hook.Values, { className: "hours-list", dataTestId: "hours-list", dataCy: "hours-list", values: hourValues, activeValue: formattedHours, onClick: handleHoursChange, valueHeight: valueHeight, maxVisible: maxVisible }));
};

exports.HourValues = HourValues;
